import PropTypes from "prop-types";

export default {
	classNameWrapper: PropTypes.string,
	tag: PropTypes.string,
	size: PropTypes.string,
	typeStyle: PropTypes.object,
};
